import React, { PureComponent } from 'react'
import PropTypes, { any } from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import * as DeviceActions from '../../../../../../actions/device'

import { Button, Column, Confirmation, Expander, Form, Headings, Input, Link, Margin, Modal, Padding } from '../../../../..'
import { deviceUpdateForm } from '../../../../../../types'

import DeviceStatus from './DeviceStatus'
import DeviceBypassAuth from './DeviceBypassAuth'
import { colors } from '../../../../../../constants'
import { bindActionCreators } from 'redux'
import { filter } from 'lodash'
import { on } from 'events'

const { FormGroup, FormHeader, Label } = Form
const trueOrFalse = ['true', 'false']
const rotations = ['Sensor', 'Landscape', 'Reverse-Landscape', 'Portrait', 'Reverse-Portrait']
const filterLevels = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
const antennaLevels = [
    { value: '[4:1]', name: '23dB - minimum detection range' },
    { value: '[4:2]', name: '33dB - medium detection range' },
    { value: '[4:3]', name: '38dB - high detection range (default)' },
    { value: '[4:4]', name: '43dB - very high detection range' },
    { value: '[4:5]', name: '48dB - maximum detection range' },
]
const playlistTypes = [
    { value: 'PLAYLIST_TYPE_4K', name: 'PLAYLIST_TYPE_4K' },
    { value: 'PLAYLIST_TYPE_HD', name: 'PLAYLIST_TYPE_HD' },
    { value: 'PLAYLIST_TYPE_HDR', name: 'PLAYLIST_TYPE_HDR' },
]

class DeviceUpdateForm extends PureComponent {
    static propTypes = {
        apks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        channels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        deviceGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        deviceTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        isAdmin: PropTypes.bool,
        isOpenAdvancedOptions: PropTypes.bool,
        device: PropTypes.shape(deviceUpdateForm).isRequired,
        deviceUID: PropTypes.string,
        errors: PropTypes.shape({
            antenna_level: PropTypes.string,
            api_url: PropTypes.string,
            apk_version: PropTypes.string,
            background_colour: PropTypes.string,
            cec_enabled: PropTypes.string,
            device_owner: PropTypes.string,
            device_type: PropTypes.string,
            disable_zoom: PropTypes.string,
            display_group: PropTypes.string,
            file_auth: PropTypes.string,
            file_url: PropTypes.string,
            filter_level: PropTypes.string,
            four_k: PropTypes.string,
            id: PropTypes.string,
            layer_enabled: PropTypes.string,
            layer_extra: PropTypes.string,
            migrated_at: PropTypes.string,
            ntp_url: PropTypes.string,
            screen_rotation: PropTypes.string,
            selected_channel: PropTypes.string,
            selected_type: PropTypes.string,
            socket_url: PropTypes.string,
            store_code: PropTypes.string,
            store_locations: PropTypes.string,
            store_sync: PropTypes.string,
            sync_delay: PropTypes.string,
            sync_offset: PropTypes.string,
            sync_timeout: PropTypes.string,
            sync_url: PropTypes.string,
            usb_serial: PropTypes.string,
            volume: PropTypes.string,
            working_close: PropTypes.string,
            working_open: PropTypes.string,
        }),
        fetchingData: PropTypes.bool,
        innerRef: PropTypes.shape({}),
        isDeviceStatusLoading: PropTypes.bool,
        isOpen: PropTypes.bool,
        onChangeForm: PropTypes.shape({
            antenna_level: PropTypes.func,
            api_url: PropTypes.func,
            apk_version: PropTypes.func,
            background_colour: PropTypes.func,
            cec_enabled: PropTypes.func,
            device_owner: PropTypes.func,
            device_type: PropTypes.func,
            disable_zoom: PropTypes.func,
            display_group: PropTypes.func,
            file_auth: PropTypes.func,
            file_url: PropTypes.func,
            filter_level: PropTypes.func,
            four_k: PropTypes.func,
            id: PropTypes.func,
            layer_enabled: PropTypes.func,
            layer_extra: PropTypes.func,
            migrated_at: PropTypes.func,
            ntp_url: PropTypes.func,
            screen_rotation: PropTypes.func,
            selected_channel: PropTypes.func,
            selected_type: PropTypes.func,
            socket_url: PropTypes.func,
            store_code: PropTypes.func,
            store_location: PropTypes.func,
            store_sync: PropTypes.func,
            sync_delay: PropTypes.func,
            sync_offset: PropTypes.func,
            sync_timeout: PropTypes.func,
            sync_url: PropTypes.func,
            usb_serial: PropTypes.func,
            volume: PropTypes.func,
            working_close: PropTypes.func,
            working_open: PropTypes.func,
        }),
        isOpenNewOptions: PropTypes.bool,
        isOpenServerOptions: PropTypes.bool,
        onChangeAdvancedOptionsVisibility: PropTypes.func,
        onChangeNewOptionsVisibility: PropTypes.func,
        onChangeServerOptionsVisibility: PropTypes.func,
        onClickCancel: PropTypes.func,
        onClickPush: PropTypes.func,
        onClickSubmit: PropTypes.func,
        onClickSubmitAndPush: PropTypes.func,
        selectedDeviceStatus: PropTypes.shape({
            device: PropTypes.string,
            store_code: PropTypes.string,
            date: PropTypes.number,
            apk_version: PropTypes.string,
            hdmi: PropTypes.bool,
        }),
        storeLocations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        deviceUID: '',
        errors: {
            antenna_level: null,
            api_url: null,
            apk_version: null,
            background_colour: null,
            cec_enabled: null,
            device_owner: null,
            device_type: null,
            disable_zoom: null,
            display_group: null,
            file_auth: null,
            file_url: null,
            filter_level: null,
            four_k: null,
            id: null,
            layer_enabled: null,
            layer_extra: null,
            migrated_at: null,
            ntp_url: null,
            screen_rotation: null,
            selected_channel: null,
            selected_type: null,
            socket_url: null,
            store_code: null,
            store_location: null,
            store_sync: null,
            sync_delay: null,
            sync_offset: null,
            sync_timeout: null,
            sync_url: null,
            usb_serial: null,
            volume: null,
            working_close: null,
            working_open: null,
        },
        fetchingData: false,
        innerRef: null,
        isOpen: false,
        isAdmin: false,
        isDeviceStatusLoading: false,
        isOpenAdvancedOptions: false,
        isOpenNewOptions: false,
        isOpenServerOptions: false,
        onChangeAdvancedOptionsVisibility: null,
        onChangeNewOptionsVisibility: null,
        onChangeServerOptionsVisibility: null,
        onClickCancel: () => null,
        onChangeForm: {
            antenna_level: () => null,
            api_url: () => null,
            apk_version: () => null,
            background_colour: () => null,
            cec_enabled: () => null,
            device_owner: () => null,
            device_type: () => null,
            disable_zoom: () => null,
            display_group: () => null,
            file_auth: () => null,
            file_url: () => null,
            filter_level: () => null,
            four_k: () => null,
            id: () => null,
            layer_enabled: () => null,
            layer_extra: () => null,
            migrated_at: () => null,
            ntp_url: () => null,
            screen_rotation: () => null,
            selected_channel: () => null,
            selected_type: () => null,
            socket_url: () => null,
            store_code: () => null,
            store_location: () => null,
            store_sync: () => null,
            sync_delay: () => null,
            sync_offset: () => null,
            sync_timeout: () => null,
            sync_url: () => null,
            volume: () => null,
            usb_serial: () => null,
            working_close: () => null,
            working_open: () => null,
        },
        onClickPush: () => null,
        onClickSubmit: () => null,
        onClickSubmitAndPush: () => null,
        selectedDeviceStatus: {},
    }

    render() {
        const {
            apks,
            channels,
            device,
            deviceGroups,
            deviceTypes,
            deviceUID,
            errors,
            fetchingData,
            isAdmin,
            isDeviceStatusLoading,
            isOpen,
            isOpenAdvancedOptions,
            isOpenNewOptions,
            isOpenServerOptions,
            onChangeAdvancedOptionsVisibility,
            onChangeForm,
            onChangeNewOptionsVisibility,
            onChangeServerOptionsVisibility,
            onClickCancel,
            onClickPush,
            onClickSubmit,
            onClickSubmitAndPush,
            selectedDeviceStatus,
            storeLocations,
            t,
        } = this.props
        const {
            antenna_level,
            api_url,
            apk_version,
            background_colour,
            cec_enabled,
            device_owner,
            device_type,
            disable_zoom,
            display_group,
            file_auth,
            file_url,
            filter_level,
            four_k,
            id,
            layer_enabled,
            layer_extra,
            manufacturer,
            migrated_at,
            model,
            ntp_url,
            screen_rotation,
            selected_channel,
            selected_type,
            sku,
            socket_url,
            store_code,
            store_location,
            store_sync,
            sync_delay,
            sync_offset,
            sync_timeout,
            sync_url,
            usb_serial,
            volume,
            working_close,
            working_open,
        } = device
        const {
            antenna_level: onChangeAntennaLevel,
            api_url: onChangeApiUrl,
            apk_version: onChangeApkVersion,
            background_colour: onChnageBackgroundColor,
            cec_enabled: onChangeCecEnabled,
            device_owner: onChangeDeviceOwner,
            device_type: onChangeType,
            disable_zoom: onChangeDisableZoom,
            display_group: onChangeDisplayGroup,
            file_auth: onChangeFileAuth,
            file_url: onChangeFileUrl,
            filter_level: onChangeFilterLevel,
            four_k: onChangeFourK,
            id: onChangeID,
            layer_enabled: onChangeLayerEnable,
            layer_extra: onChangeLayerExtra,
            manufacturer: onChangeManufacturer,
            migrated_at: onChangeMigratedAt,
            model: onChangeModel,
            ntp_url: onChangeNtpUrl,
            screen_rotation: onChangeScreenRotation,
            selected_channel: onChangeSelectedChannel,
            selected_type: onChangeSelectedType,
            sku: onChangeSku,
            socket_url: onChangeSocketUrl,
            store_code: onChangeStoreCode,
            store_location: onChangeStoreLocation,
            store_sync: onChangeStoreSync,
            sync_delay: onChnageSyncDelay,
            sync_offset: onChangeSyncOffset,
            sync_timeout: onChangeSyncTimeout,
            sync_url: onChangeSyncUrl,
            usb_serial: onChangeUsbSerial,
            volume: onChangeVolume,
            working_close: onChangeWorkingClose,
            working_open: onChangeWorkingOpen,
        } = onChangeForm
        const {
            general: generalError,
            antenna_level: antenna_level_error,
            api_url: api_url_error,
            apk_version: apk_version_error,
            background_colour: background_colour_error,
            cec_enabled: cec_enabled_error,
            device_owner: device_owner_error,
            device_type: device_type_error,
            disable_zoom: disable_zoom_error,
            display_group: display_group_error,
            file_auth: file_auth_error,
            file_url: file_url_error,
            filter_level: filter_level_error,
            four_k: four_k_error,
            id: id_error,
            layer_enabled: layer_enabled_error,
            layer_extra: layer_extra_error,
            manufacturer: manufacturer_error,
            migrated_at: migrated_at_error,
            model: model_error,
            ntp_url: ntp_url_error,
            screen_rotation: screen_rotation_error,
            selected_channel: selected_channel_error,
            selected_type: selected_type_error,
            sku: sku_error,
            socket_url: socket_url_error,
            store_code: store_code_error,
            store_location: store_location_error,
            store_sync: store_sync_error,
            sync_delay: sync_delay_error,
            sync_offset: sync_offset_error,
            sync_timeout: sync_timeout_error,
            sync_url: sync_url_error,
            usb_serial: usb_serial_error,
            volume: volume_error,
            working_close: working_close_error,
            working_open: working_open_error,
        } = errors

        const booleanValues = [
            { value: true, name: t('enabled') },
            { value: false, name: t('disabled') },
        ]

        const creatingNewDevice = !deviceUID

        const SaveAndPushLabel = creatingNewDevice ? t('create') : t('save-push-settings')

        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} scrollable>
                <Form>
                    <FormHeader>
                        <Padding left right bottom size="sm">
                            <Column>{deviceUID ? t('Update device') : t('Create device')}</Column>
                            <Column right>{deviceUID}</Column>
                        </Padding>
                    </FormHeader>
                    <FormGroup title={t('Device options')} scrollable>
                        <Label id="id" label="ID" error={id_error}>
                            <Input
                                id="id"
                                name="id"
                                type="text"
                                onChange={onChangeID}
                                size="md"
                                value={id}
                                error={!!id_error}
                                disabled={fetchingData || deviceUID}
                            />
                        </Label>
                        <Label id="store_location" label={t('Location')} error={store_location_error}>
                            <Input
                                id="store_location"
                                name="store_location"
                                type="select"
                                onChange={onChangeStoreLocation}
                                size="md"
                                value={store_location}
                                values={storeLocations}
                                error={!!store_location_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="device_type" label={t('Device type')} error={store_location_error}>
                            <Input
                                id="device_type"
                                name="device_type"
                                type="select"
                                onChange={onChangeType}
                                size="md"
                                value={device_type}
                                values={deviceTypes}
                                error={!!device_type_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="selected_channel" label={t('Channel')} error={selected_channel_error}>
                            <Input
                                id="selected_channel"
                                name="selected_channel"
                                type="select"
                                onChange={onChangeSelectedChannel}
                                size="md"
                                value={selected_channel}
                                values={channels.concat('none')}
                                error={!!selected_channel_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label id="store_code" label={t('Store code')} error={store_code_error}>
                            <Input
                                id="store_code"
                                name="store_code"
                                type="text"
                                onChange={onChangeStoreCode}
                                size="sm"
                                value={store_code}
                                error={!!store_code_error}
                                disabled={fetchingData || !deviceUID}
                            />
                        </Label>
                        <Label label={t('sku')} error={sku_error}>
                            <Input name="sku" type="text" onChange={onChangeSku} size="sm" value={sku} error={!!sku_error} disabled={fetchingData} />
                        </Label>
                        <Label label={t('manufacturer')} error={manufacturer_error}>
                            <Input
                                name="manufacturer"
                                type="text"
                                onChange={onChangeManufacturer}
                                size="md"
                                value={manufacturer}
                                error={!!manufacturer_error}
                                disabled={fetchingData}
                            />
                        </Label>
                        <Label label={t('model')} error={model_error}>
                            <Input name="model" type="text" onChange={onChangeModel} size="md" value={model} error={!!model_error} disabled={fetchingData} />
                        </Label>
                        <Padding top bottom size="xs">
                            <Expander
                                icon="cogs"
                                header={t('Advanced Options')}
                                disabled={fetchingData}
                                isOpen={isOpenAdvancedOptions}
                                changeVisibility={onChangeAdvancedOptionsVisibility}
                            >
                                <Label id="apk_version" label={t('Target APK Version')} error={apk_version_error}>
                                    <Input
                                        id="apk_version"
                                        name="apk_version"
                                        type="select"
                                        onChange={onChangeApkVersion}
                                        size="md"
                                        value={apk_version}
                                        values={apks}
                                        error={!!apk_version_error}
                                    />
                                </Label>
                                <Label id="display_group" label={t('Display group')} error={store_location_error}>
                                    <Input
                                        id="display_group"
                                        name="display_group"
                                        type="select"
                                        onChange={onChangeDisplayGroup}
                                        size="md"
                                        value={display_group}
                                        values={deviceGroups}
                                        error={!!display_group_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="migrated_at" label={t('device-migrated')} error={selected_type_error}>
                                    {!migrated_at && (
                                        <Link
                                            onClick={() =>
                                                onChangeMigratedAt({
                                                    target: {
                                                        name: 'migrated_at',
                                                        value: new Date().getTime(),
                                                    },
                                                })
                                            }
                                        >
                                            {t('device-migrate')}
                                        </Link>
                                    )}
                                    {migrated_at && (
                                        <Input
                                            id="migrated_at"
                                            name="migrated_at"
                                            type="date"
                                            onChange={(value) =>
                                                onChangeMigratedAt({
                                                    target: {
                                                        name: 'migrated_at',
                                                        value,
                                                    },
                                                })
                                            }
                                            size="sm"
                                            value={migrated_at}
                                            error={!!migrated_at_error}
                                            disabled={fetchingData}
                                            withTime
                                        />
                                    )}
                                </Label>
                                <Label id="store_sync" label={t('Store sync')} error={store_sync_error}>
                                    <Input
                                        id="store_sync"
                                        name="store_sync"
                                        type="select"
                                        onChange={onChangeStoreSync}
                                        size="sm"
                                        value={store_sync}
                                        values={trueOrFalse}
                                        error={!!store_sync_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="volume" label={t('Volume')} error={volume_error}>
                                    <Input
                                        id="volume"
                                        name="volume"
                                        type="text"
                                        onChange={onChangeVolume}
                                        size="sm"
                                        value={volume}
                                        error={!!volume_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="layer_enabled" label={t('Layer')} error={layer_enabled_error}>
                                    <Input
                                        id="layer_enabled"
                                        name="layer_enabled"
                                        type="select"
                                        onChange={onChangeLayerEnable}
                                        size="sm"
                                        value={layer_enabled}
                                        values={trueOrFalse}
                                        error={!!layer_enabled_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="background_colour" label={t('Background colour')} error={background_colour_error}>
                                    <Input
                                        id="background_colour"
                                        name="background_colour"
                                        type="text"
                                        onChange={onChnageBackgroundColor}
                                        size="sm"
                                        value={background_colour}
                                        error={!!background_colour_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="cec_enabled" label={t('CEC Enabled')} error={cec_enabled_error}>
                                    <Input
                                        id="cec_enabled"
                                        name="cec_enabled"
                                        type="select"
                                        onChange={onChangeCecEnabled}
                                        size="sm"
                                        value={cec_enabled}
                                        values={trueOrFalse}
                                        error={!!cec_enabled_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="screen_rotation" label={t('Rotation')} error={screen_rotation_error}>
                                    <Input
                                        id="screen_rotation"
                                        name="screen_rotation"
                                        type="select"
                                        onChange={onChangeScreenRotation}
                                        size="md"
                                        value={screen_rotation}
                                        values={rotations}
                                        error={!!screen_rotation_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="sync_offset" label={t('Sync offset')} error={sync_offset_error}>
                                    <Input
                                        id="sync_offset"
                                        name="sync_offset"
                                        type="text"
                                        onChange={onChangeSyncOffset}
                                        size="sm"
                                        value={sync_offset}
                                        error={!!sync_offset_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="sync_delay" label={t('Sync delay')} error={sync_delay_error}>
                                    <Input
                                        id="sync_delay"
                                        name="sync_delay"
                                        type="text"
                                        onChange={onChnageSyncDelay}
                                        size="sm"
                                        value={sync_delay}
                                        error={!!sync_delay_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="sync_timeout" label={t('Sync timeout')} error={sync_timeout_error}>
                                    <Input
                                        id="sync_timeout"
                                        name="sync_timeout"
                                        type="text"
                                        onChange={onChangeSyncTimeout}
                                        size="sm"
                                        value={sync_timeout}
                                        error={!!sync_timeout_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="working_open" label={t('Opening time')} error={working_open_error}>
                                    <Input
                                        id="working_open"
                                        name="working_open"
                                        type="text"
                                        onChange={onChangeWorkingOpen}
                                        size="sm"
                                        value={working_open}
                                        error={!!working_open_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="working_close" label={t('Closing time')} error={working_close_error}>
                                    <Input
                                        id="working_close"
                                        name="working_close"
                                        type="text"
                                        onChange={onChangeWorkingClose}
                                        size="sm"
                                        value={working_close}
                                        error={!!working_close_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="layer_extra" label={t('Layer extra')} error={layer_extra_error}>
                                    <Input
                                        id="layer_extra"
                                        name="layer_extra"
                                        type="text"
                                        onChange={onChangeLayerExtra}
                                        size="md"
                                        value={layer_extra}
                                        error={!!layer_extra_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="device_owner" label={t('Device owner')} error={device_owner_error}>
                                    <Input
                                        id="device_owner"
                                        name="device_owner"
                                        type="select"
                                        onChange={onChangeDeviceOwner}
                                        size="sm"
                                        value={device_owner}
                                        values={trueOrFalse}
                                        error={!!device_owner_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="selected_type" label={t('Playlist type')} error={selected_type_error}>
                                    <Input
                                        id="selected_type"
                                        name="selected_type"
                                        type="select"
                                        onChange={onChangeSelectedType}
                                        size="md"
                                        value={selected_type}
                                        values={playlistTypes}
                                        error={!!selected_type_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="disable_zoom" label={t('disable zoom')} error={disable_zoom_error}>
                                    <Input
                                        id="disable_zoom"
                                        name="disable_zoom"
                                        type="select"
                                        onChange={onChangeDisableZoom}
                                        size="sm"
                                        value={disable_zoom}
                                        values={booleanValues}
                                        error={!!disable_zoom_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="4k" label={t('4K')} error={four_k_error}>
                                    <Input
                                        id="four_k"
                                        name="four_k"
                                        type="select"
                                        onChange={onChangeFourK}
                                        size="sm"
                                        value={four_k}
                                        values={booleanValues}
                                        error={!!four_k_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                            </Expander>
                        </Padding>
                    </FormGroup>
                    <FormGroup title={t('nexmosphere options')}>
                        <Padding top bottom size="xs">
                            <Expander
                                icon="cogs"
                                header={t('nexmosphere options')}
                                disabled={fetchingData}
                                isOpen={isOpenNewOptions}
                                changeVisibility={onChangeNewOptionsVisibility}
                            >
                                <Label id="usb_serial" label={t('device.usb_serial')} error={usb_serial_error}>
                                    <Input
                                        id="usb_serial"
                                        name="usb_serial"
                                        type="select"
                                        onChange={onChangeUsbSerial}
                                        size="sm"
                                        value={usb_serial}
                                        values={[
                                            { value: true, name: t('enabled') },
                                            { value: false, name: t('disabled') },
                                        ]}
                                        error={!!usb_serial_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="filter_level" label={t('filter level')} error={filter_level_error}>
                                    <Input
                                        id="filter_level"
                                        name="filter_level"
                                        type="select"
                                        onChange={onChangeFilterLevel}
                                        size="sm"
                                        value={filter_level}
                                        values={filterLevels}
                                        error={!!filter_level_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="antenna_level" label={t('antenna level')} error={antenna_level_error}>
                                    <Input
                                        id="antenna_level"
                                        name="antenna_level"
                                        type="select"
                                        onChange={onChangeFilterLevel}
                                        size="sm"
                                        value={antenna_level}
                                        values={antennaLevels}
                                        error={!!antenna_level_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                            </Expander>
                        </Padding>
                    </FormGroup>
                    <FormGroup title={t('Server options')}>
                        <Padding top bottom size="xs">
                            <Expander
                                icon="cogs"
                                header={t('Server options')}
                                disabled={fetchingData}
                                isOpen={isOpenServerOptions}
                                changeVisibility={onChangeServerOptionsVisibility}
                            >
                                <Label id="api_url" label={t('Api server URL')} error={api_url_error}>
                                    <Input
                                        id="api_url"
                                        name="api_url"
                                        type="text"
                                        onChange={onChangeApiUrl}
                                        size="md"
                                        value={api_url}
                                        error={!!api_url_error}
                                        disabled={fetchingData || (deviceUID && !isAdmin)}
                                    />
                                </Label>
                                <Label id="socket_url" label="Socket server URL" error={socket_url_error}>
                                    <Input
                                        id="socket_url"
                                        name="socket_url"
                                        type="text"
                                        onChange={onChangeSocketUrl}
                                        size="md"
                                        value={socket_url}
                                        error={!!socket_url_error}
                                        disabled={fetchingData || (deviceUID && !isAdmin)}
                                    />
                                </Label>
                                <Label id="sync_url" label={t('Sync server URL')} error={sync_url_error}>
                                    <Input
                                        id="sync_url"
                                        name="sync_url"
                                        type="text"
                                        onChange={onChangeSyncUrl}
                                        size="md"
                                        value={sync_url}
                                        error={!!sync_url_error}
                                        disabled={fetchingData || (deviceUID && !isAdmin)}
                                    />
                                </Label>
                                <Label id="file_url" label={t('File server URL')} error={file_url_error}>
                                    <Input
                                        id="file_url"
                                        name="file_url"
                                        type="text"
                                        onChange={onChangeFileUrl}
                                        size="md"
                                        value={file_url}
                                        error={!!file_url_error}
                                        disabled={fetchingData || (deviceUID && !isAdmin)}
                                    />
                                </Label>
                                <Label id="ntp_url" label={t('NTP server URL')} error={ntp_url_error}>
                                    <Input
                                        id="ntp_url"
                                        name="ntp_url"
                                        type="text"
                                        onChange={onChangeNtpUrl}
                                        size="md"
                                        value={ntp_url}
                                        error={!!ntp_url_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                                <Label id="file_auth" label={t('File server Auth')} error={file_auth_error}>
                                    <Input
                                        id="file_auth"
                                        name="file_auth"
                                        type="select"
                                        onChange={onChangeFileAuth}
                                        size="md"
                                        value={file_auth}
                                        values={trueOrFalse}
                                        error={!!file_auth_error}
                                        disabled={fetchingData}
                                    />
                                </Label>
                            </Expander>
                        </Padding>
                    </FormGroup>
                    <DeviceStatus data={selectedDeviceStatus} isLoading={isDeviceStatusLoading} />
                    <Margin size="md">
                        <Headings.H5 color={colors.red}>{generalError}</Headings.H5>
                    </Margin>
                    <div className="modal-bottom-device">
                        <Margin>
                            <Column width="30%">{!creatingNewDevice && !fetchingData && <DeviceBypassAuth deviceId={deviceUID} />}</Column>
                            <Column right width="70%">
                                <Margin right inline size="xs">
                                    <Button theme="lightDanger" onClick={onClickCancel} size="sm">
                                        {t('Cancel')}
                                    </Button>
                                </Margin>
                                {!creatingNewDevice && !fetchingData && (
                                    <Margin right inline size="xs">
                                        <Confirmation
                                            onConfirm={onClickSubmit}
                                            disabled={fetchingData}
                                            confirmation={t('update-settings-confirmation-body', {
                                                device: id,
                                            })}
                                            ok={t('settings-save')}
                                        >
                                            <Button disabled={fetchingData} size="sm" theme="secondary" title={t('settings-save', { context: 'description' })}>
                                                {t('settings-save')}
                                            </Button>
                                        </Confirmation>
                                    </Margin>
                                )}
                                {!creatingNewDevice && !fetchingData && (
                                    <Margin right inline size="xs">
                                        <Confirmation
                                            onConfirm={onClickPush}
                                            disabled={fetchingData}
                                            confirmation={t('push-settings-confirmation-body', {
                                                device: id,
                                            })}
                                            ok={t('Push Settings')}
                                        >
                                            <Button disabled={fetchingData} size="sm" theme="secondary" title={t('settings-push', { context: 'description' })}>
                                                {t('Push Settings')}
                                            </Button>
                                        </Confirmation>
                                    </Margin>
                                )}

                                <Confirmation
                                    onConfirm={onClickSubmitAndPush}
                                    disabled={fetchingData}
                                    confirmation={t('update-push-settings-confirmation-body', {
                                        device: id,
                                    })}
                                    ok={SaveAndPushLabel}
                                >
                                    <Button
                                        size="sm"
                                        theme={fetchingData ? 'loading' : 'forestGreen'}
                                        title={t('settings-save-push', { context: 'description' })}
                                    >
                                        {fetchingData ? '...' : SaveAndPushLabel}
                                    </Button>
                                </Confirmation>
                            </Column>
                        </Margin>
                    </div>
                </Form>
            </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...DeviceActions,
        },
        dispatch
    )

export default connect(mapDispatchToProps)(withTranslation()(DeviceUpdateForm))
